export default __webpack_public_path__ + "static/media/Apple iPad Pro 11.17d28d60.png";